import { render, staticRenderFns } from "./centerCharts.vue?vue&type=template&id=4888589e&"
import script from "./centerCharts.vue?vue&type=script&lang=js&"
export * from "./centerCharts.vue?vue&type=script&lang=js&"
import style0 from "./centerCharts.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports